var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.66699,
    cy: 5.83325,
    r: 1.33333,
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.66634,
    cy: 3.83333,
    r: 0.666667,
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.5,
    r: 2.33333,
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.33333,
    cy: 9.50008,
    r: 1.66667,
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/food_icon.a36f645c27db63a1510eb09dec7bdf04.svg";
export { ForwardRef as ReactComponent };